export const ASSETS = {
  mangaMap: "/manhattan-map.jpg",
  cartIcon: "/cart-drawn.png",
  cartPhoto: "/cart_real_1.jpg",
  gallery: [
    "/cart_real_3.jpg",
    "/cart_real_4.jpg",
    "/cart_real_1.jpg",
    "/cart_real_5.jpg",
    "/cart_real_6.jpg",
    "/cart_real_7.jpg",
    "/cart_real_8.jpg",
  ],
};

export const CONTACT = {
  email: "info@santachiaragelati.com",
  phone: "+1 (929) 424-5955",
  instagram: "https://instagram.com/santachiaracaffe",
  instagramHandle: "@santachiaracaffe",
};
